import actions from './actions'

const initialState = {
  totalRegistrations: {},
  timeUsage: {},
  sceneData: [],
  currentData: {},
  subscribedScenes: [],
  presenceData: [],
  allChannels: [],
  totalOccupancy: '',
  totalChannels: '',
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
